import ApiClient from './ApiClient';

class LossReasonsAPI extends ApiClient {
  constructor() {
    super('loss_reasons', { accountScoped: true });
  }
}

export default new LossReasonsAPI();
